import React from 'react';
import Snowfall from 'react-snowfall';

function CustomSnowfall() {
  return <Snowfall color="white" snowflakeCount={50} />;
}

export default CustomSnowfall;
